import React, { ReactNode } from 'react';
import { logoutContext, useLogOutConfig } from './useLogOutConfig';

type Props = {
  children: ReactNode;
};

export function LogoutConfigProvider(props: Props) {
  const { children } = props;
  const logoutConfig = useLogOutConfig();
  const { Provider } = logoutContext;
  return <Provider value={logoutConfig}>{children}</Provider>;
}
